<template>
  <v-container fluid class="pa-0 mo-bg" style="min-height: 87vh">
    <v-row class="ma-0 pa-0" align="center" justify="center">
      <v-col cols="12" sm="10" md="8" lg="7">
        <v-sheet
          class="mo-panel neo-surface elevation-3 rounded-xl mx-auto"
          max-width="820"
        >
          <v-toolbar flat dense class="mo-toolbar">
            <v-btn icon small class="white--text mr-1" @click="goBack">
              <v-icon color="white" small>mdi-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title class="white--text d-flex align-center">
              <v-icon left color="white" class="mr-2">mdi-factory</v-icon>
              Detail Memo Item
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              small
              class="white--text"
              :disabled="loading"
              @click="refreshData"
            >
              <v-icon color="white" small :class="{ spin: loading }"
                >mdi-refresh</v-icon
              >
            </v-btn>
          </v-toolbar>
          <div class="position-relative">
            <canvas ref="bgCanvas" class="bg-canvas"></canvas>
            <div class="pa-6 neo-surface">
              <v-skeleton-loader
                v-if="loading"
                type="article, table, actions"
              />
              <div v-else>
                <v-row dense>
                  <v-col cols="12">
                    <div class="mo-header value emphasis-1">
                      {{ memo.no_memo }}
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">NO SO</div>
                    <div class="value">{{ memo.no_so }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">Tgl. Order</div>
                    <div class="value">{{ memo.order_date }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">PLANT</div>
                    <div class="value">{{ memo.plant }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">CUSTOMER</div>
                    <div class="value">{{ memo.customer }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">NAMA PRODUK</div>
                    <div class="value">{{ product.name }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">KODE PRODUK</div>
                    <div class="value">{{ product.code }}</div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">QTY DEMAND</div>
                    <div class="value">
                      {{ formatNumber(product.qty) }} {{ product.uom }}
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="label">TOTAL QTY MUAT</div>
                    <div class="value">
                      {{ formatNumber(product.loaded_qty) }} {{ product.uom }}
                    </div>
                  </v-col>
                </v-row>
                <v-row dense class="mt-4">
                  <v-col cols="12">
                    <v-simple-table dense class="detail-table">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <!-- <th class="text-left">No.</th> -->
                            <th class="text-left">Lot No</th>
                            <th class="text-left">Palet</th>
                            <th class="text-left">Mesin</th>
                            <th class="text-left">Shift</th>
                            <th class="text-left">Qty Muat</th>
                            <th class="text-left"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="!detailRows.length">
                            <td colspan="5" class="text-center empty-state">
                              Data detail tidak tersedia.
                            </td>
                          </tr>
                          <tr v-for="(row, index) in detailRows" :key="index">
                            <!-- <td>{{ index + 1 }}</td> -->
                            <td style="font-size: 10px">{{ row.lotNo }}</td>
                            <td style="font-size: 10px">{{ row.palletNo }}</td>
                            <td style="font-size: 10px">
                              {{ twoWords(row.machine) }}
                            </td>
                            <td style="font-size: 10px">
                              {{ twoWords(row.shift) }}
                            </td>
                            <td style="font-size: 10px">{{ row.qty }}</td>
                            <td>
                              <v-btn
                                icon
                                x-small
                                @click="deleteLoadingItem(row)"
                                ><v-icon color="red" x-small
                                  >mdi-delete</v-icon
                                ></v-btn
                              >
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
                <v-row class="mt-4" dense>
                  <v-col cols="12">
                    <v-btn block class="neo-btn" @click="openScanPallet"
                      >SCAN PASSET</v-btn
                    >
                  </v-col>
                  <!-- <v-col cols="12" class="mt-1">
                    <v-btn block class="neo-btn" @click="submitMemo"
                      >SUBMIT</v-btn
                    >
                  </v-col> -->
                  <v-col cols="12" class="mt-1">
                    <v-btn block class="neo-btn" @click="cancelMemo"
                      >KEMBALI</v-btn
                    >
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </v-sheet>
      </v-col>
    </v-row>

    <!-- Notif sukses simpan -->
    <v-dialog v-model="dialogSaved" max-width="420">
      <v-card class="neo-surface pa-5 text-center">
        <v-icon color="#43A047" large>mdi-check-circle</v-icon>
        <div class="mt-2 strong">Data berhasil disimpan.</div>
        <div class="mt-3">
          <v-btn class="neo-btn" @click="onSubmitOk">OK</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Notif konfirmasi -->
    <v-dialog v-model="dialogConfirm" max-width="420">
      <v-card class="neo-surface pa-5 text-center">
        <v-icon color="orange" large>mdi-alert</v-icon>
        <div class="mt-2 strong">Anda yakin data sudah sesuai</div>
        <div class="mt-3">
          <v-btn class="neo-btn" @click="confirmSubmit">YA, LANJUTKAN</v-btn>
          <v-btn class="neo-btn" @click="cancelSubmit">BATAL</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Notif warning minimum jml muatan-->
    <v-dialog v-model="dialogWarning" max-width="380">
      <v-card class="neo-surface pa-5 text-center">
        <v-icon class="warning-icon" large>mdi-alert-circle</v-icon>
        <div class="mt-3 strong">
          {{ warningMessage || 'Jumlah muatan minimal 1.' }}
        </div>
        <div class="mt-4">
          <v-btn class="neo-btn" @click="dialogWarning = false">MENGERTI</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <production-scanner
      v-model="dialogScanPallet"
      title="Scan Form Pallet"
      input-label="Scan/Tempel Nomor Form Pallet"
      :action-label="'Cari'"
      :persistent="false"
      :auto-close-on-scan="true"
      :auto-emit-on-scan="true"
      @scanned="handlePalletScanned"
    />

    <pallet-detail-component
      v-model="dialogPalletDetail"
      :loading="palletDetailLoading"
      :detail="palletDetail || {}"
      :memoItem="product || {}"
      @saveQty="saveQty"
    />
  </v-container>
</template>
<script>
import axios from 'axios'
import buildType from '../../../../services/buildType'
import { mapGetters, mapMutations } from 'vuex'

const createEmptyMemo = () => ({
  no_memo: '-',
  no_so: '-',
  order_date: '-',
  plant: '-',
  customer: '-'
})

const createEmptyProduct = () => ({
  id: '',
  code: '',
  name: '-',
  qty: 0,
  loaded_qty: 0,
  uom: '-',
  selectedLot: 0
})

export default {
  name: 'MemoItemDetail',
  components: {
    ProductionScanner: () =>
      import('../../../home/components/ProductionScanner.vue'),
    PalletDetailComponent: () => import('./PalletDetailComponent.vue')
  },
  data() {
    return {
      passedApi: buildType.apiURL('passed'),
      loading: true,
      memo: createEmptyMemo(),
      product: createEmptyProduct(),
      detailRows: [],
      dialogScanPallet: false,
      dialogConfirm: false,
      dialogSaved: false,
      dialogPalletDetail: false,
      palletDetailLoading: false,
      palletDetail: null,

      dialogWarning: false,
      warningMessage: ''
    }
  },
  watch: {
    '$route.fullPath'() {
      this.refreshData()
    }
  },
  computed: {
    ...mapGetters(['getMemoItem'])
  },
  methods: {
    ...mapMutations(['setMemoItem']),
    async showConfirmation(title, text, btnYes, btnNo) {
      if (!this.$swal) {
        console.error('SweetAlert instance not available')
        return
      }

      return this.$swal.fire({
        title: title,
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: btnYes,
        cancelButtonText: btnNo,
        focusCancel: true
      })
    },
    async deleteLoadingItem(data) {
      const { isConfirmed } =
        (await this.showConfirmation(
          'Hapus pallet ini?',
          'Data yang sudah terhapus tidak dapat dikembalikan',
          'Ya, hapus',
          'Batal'
        )) || {}

      if (!isConfirmed) return

      const url = `${this.passedApi}memo_pallet/delete`
      const body = {
        memo_loading_item_id: data.raw.memo_loading_item_id,
        manufacturing_order_pallet_id: data.raw.manufacturing_order_pallet_id
      }
      try {
        const response = await axios.post(url, body)
        const payload = response && response.data
        if (payload && payload.status_code === '00' && payload.data) {
          this.$swal.fire('Success', payload.status_msg, 'success')
          this.fetchItemDetail()
        } else {
          const message = (payload && payload.status_msg) || 'Gagal delete data'
          this.$swal.fire('Info', message, 'warning')
        }
      } catch (error) {
        console.error('saveLoading error', error)
        this.$swal.fire('Error', 'Gagal delete data', 'error')
      }
    },
    twoWords(value) {
      if (value == null) return '-'
      const text = value.toString().trim()
      if (!text) return '-'
      const parts = text.split(/\s+/)
      return parts.slice(0, 2).join(' ')
    },
    saveQty(val) {
      const v = Number(val.qty_loading)
      if (!v || isNaN(v) || v < 1) {
        this.warningMessage = 'Masukkan jumlah loading minimal 1.'
        this.dialogWarning = true
        return
      }
      // this.dialogPalletDetail = false
      // this.palletDetail = null
      this.saveLoading(val)
    },
    async saveLoading({ pallet_id, qty_loading }) {
      this.loading = true

      try {
        const { data: payload } = await axios.post(
          `${this.passedApi}memo_pallet/load`,
          {
            memo_id: this.memo?.memo_id,
            memo_loading_item_id: this.$route.query.id,
            manufacturing_order_pallet_id: pallet_id,
            qty_loading,
            user_id: 1,
            user_name: 'Administrator'
          }
        )

        const ok = payload?.status_code === '00' && payload?.data
        if (!ok) {
          const message = payload?.status_msg || 'Gagal update muatan'
          if (this.$swal) {
            this.$swal.fire('Info', message, 'warning')
          }
          return
        }

        if (this.$swal) {
          this.$swal.fire('Success', payload.status_msg, 'success')
        }
        await this.fetchItemDetail()
      } catch (error) {
        console.error('saveLoading error', error)
        if (this.$swal) {
          this.$swal.fire('Error', 'Gagal update muatan', 'error')
        }
      } finally {
        this.loading = false
        this.dialogPalletDetail = false
      }
    },
    onSubmitOk() {
      this.dialogSaved = false
    },
    cancelMemo() {
      this.goBack()
    },
    openScanPallet() {
      this.dialogScanPallet = true
    },
    handlePalletScanned(code) {
      const palletNo = (code || '').toString().trim()
      if (!palletNo) return
      if (palletNo.length < 3) {
        this.$swal.fire('Info', 'Data tidak ditemukan', 'warning')
        return
      }
      this.dialogScanPallet = false
      this.fetchPalletDetail(palletNo)
    },
    submitMemo() {
      this.dialogConfirm = true
    },
    confirmSubmit() {
      this.dialogConfirm = false
      this.dialogSaved = true
    },
    cancelSubmit() {
      this.dialogConfirm = false
    },
    goBack() {
      this.setMemoItem(null)
      if (this.$router) this.$router.back()
    },
    formatNumber(value) {
      if (value == null || value === '') return '0'
      const parsed = Number(value)
      if (Number.isNaN(parsed)) return String(value)
      try {
        return parsed.toLocaleString('id-ID')
      } catch (err) {
        return String(parsed)
      }
    },
    formatDateTime(value) {
      if (!value) return '-'
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return String(value)
      const pad = (num) => (num < 10 ? `0${num}` : String(num))
      return (
        `${pad(date.getDate())}-${pad(
          date.getMonth() + 1
        )}-${date.getFullYear()}` +
        ` ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
          date.getSeconds()
        )}`
      )
    },
    drawBackground() {
      const canvas = this.$refs.bgCanvas
      if (!canvas) return
      const container = canvas.parentElement
      const w = container.clientWidth
      const h = 220
      canvas.width = w
      canvas.height = h
      const ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, w, h)
      const g1 = ctx.createRadialGradient(
        w * 0.25,
        h * 0.5,
        10,
        w * 0.25,
        h * 0.5,
        170
      )
      g1.addColorStop(0, 'rgba(144,202,249,.35)')
      g1.addColorStop(1, 'rgba(144,202,249,0)')
      ctx.fillStyle = g1
      ctx.beginPath()
      ctx.arc(w * 0.25, h * 0.55, 150, 0, Math.PI * 2)
      ctx.fill()
      const g2 = ctx.createRadialGradient(
        w * 0.8,
        h * 0.2,
        10,
        w * 0.8,
        h * 0.2,
        150
      )
      g2.addColorStop(0, 'rgba(165,214,167,.35)')
      g2.addColorStop(1, 'rgba(165,214,167,0)')
      ctx.fillStyle = g2
      ctx.beginPath()
      ctx.arc(w * 0.8, h * 0.25, 140, 0, Math.PI * 2)
      ctx.fill()
    },
    mapDetailRows(list) {
      if (!Array.isArray(list)) return []
      return list.map((row, index) => ({
        key:
          row.memo_loading_item_id ||
          row.manufacturing_order_pallet_id ||
          `${index}`,
        lotNo: row.lot_no || '-',
        palletNo: (
          row.passed_no ||
          row.manufacturing_order_pallet_id ||
          '-'
        ).slice(-5),
        machine: row.machine_name || '-',
        shift: row.shift_name || '-',
        qty: Number(row.qty || 0),
        raw: row
      }))
    },
    async fetchPalletDetail(palletNo) {
      this.dialogPalletDetail = true
      this.palletDetailLoading = true
      this.palletDetail = null

      const url = `${this.passedApi}palletorder/detail/${encodeURIComponent(
        palletNo
      )}`

      try {
        const response = await axios.get(url)
        const payload = response && response.data
        if (payload && payload.status_code === '00' && payload.data) {
          this.palletDetail = payload.data
        } else {
          const message =
            (payload && payload.status_msg) || 'Detail pallet tidak ditemukan'
          this.$swal.fire('Info', message, 'warning')
          this.dialogPalletDetail = false
        }
      } catch (error) {
        console.error('fetchPalletDetail error', error)

        this.$swal.fire('Error', 'Gagal mengambil detail pallet', 'error')
        this.dialogPalletDetail = false
      } finally {
        this.palletDetailLoading = false
      }
    },
    async fetchItemDetail() {
      console.log('fetchItemDetail>>>>', this.getMemoItem)
      const itemId = (
        (this.$route &&
          this.$route.query &&
          (this.$route.query.itemId || this.$route.query.id)) ||
        ''
      )
        .toString()
        .trim()

      if (!itemId && !this.getMemoItem) {
        this.loading = false

        this.$swal.fire('Info', 'ID & detail memo tidak tersedia', 'warning')
        this.goBack()
        return
      }

      this.detailRows = []
      const xMemo = {
        memo_id: this.getMemoItem.memo_id,
        no_memo: this.getMemoItem.no_memo || '-',
        no_so: this.getMemoItem.so_no || '-',
        order_date: this.formatDateTime(this.getMemoItem.order_date),
        plant: this.getMemoItem.company_name || '-',
        customer: this.getMemoItem.customer || '-'
      }
      this.getLoadingMemoItem(itemId, xMemo)
    },
    async getLoadingMemoItem(itemId, xMemo) {
      this.loading = true
      try {
        const url = `${this.passedApi}loading_memo/detail_item/${encodeURIComponent(
          itemId
        )}`
        const response = await axios.get(url)
        const payload = response && response.data
        if (payload && payload.status_code === '00' && payload.data) {
          const data = payload.data
          console.log('memo item >>>', data)
          const xProduct = {
            id: itemId,
            code: data.product_code || '-',
            name:
              data.product_name || data.description || '-',
            qty: Number(data.qty || 0),
            loaded_qty: Number(data.loaded_qty || 0),
            uom: data.uom_name || '-'
            // selectedLot: Number(data.selected_lot || 0)
          }

          this.memo = { ...createEmptyMemo(), ...xMemo }
          this.product = { ...createEmptyProduct(), ...xProduct }
          this.getMemoPallet(itemId)
        }
      } catch (error) {
        console.error('getLoadingMemoItem error', error)

        this.$swal.fire('Error', 'Gagal mengambil loading memo item', 'error')
      } finally {
        this.loading = false
      }
    },
    async getMemoPallet(itemId) {
      this.loading = true
      try {
        const url = `${this.passedApi}memo_pallet/detail/${encodeURIComponent(
          itemId
        )}`
        const response = await axios.get(url)
        const payload = response && response.data
        if (payload && payload.status_code === '00' && payload.data) {
          const data = payload.data
          console.log('memo pallet >>>', data)
          this.detailRows = this.mapDetailRows(data.items)
        } else {
          // this.handleDataNotFound(
          //   (payload && payload.status_msg) || 'Data detail tidak ditemukan'
          // )
        }
      } catch (error) {
        console.error('getMemoPallet error', error)

        this.$swal.fire('Error', 'Gagal mengambil detail item memo', 'error')
        // this.goBack()
      } finally {
        this.loading = false
      }
    },
    handleDataNotFound(message) {
      this.detailRows = []
      //  this.$swal.fire('Info', message, 'warning')
      // this.goBack()
    },
    refreshData() {
      this.fetchItemDetail()
    }
  },
  mounted() {
    this.$nextTick(() => this.drawBackground())
    window.addEventListener('resize', this.drawBackground)
    this.fetchItemDetail()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.drawBackground)
  }
}
</script>

<style scoped>
.mo-toolbar {
  background: linear-gradient(135deg, #90caf9 0%, #a5d6a7 100%);
}
.mo-bg {
  background: linear-gradient(180deg, #fafcff 0%, #ffffff 70%);
}
.mo-header {
  text-align: center;
  min-height: 28px;
  padding-top: 2px;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
  color: #37474f;
}
.mo-panel {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
}
.bg-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 220px;
  pointer-events: none;
}
.neo-surface {
  --bg: #f3f6fb;
  background: var(--bg) !important;
}
.label {
  color: #6b7280;
  font-size: 0.85rem;
  margin-bottom: 2px;
}
.value {
  color: #263238;
}
.value.emphasis-1 {
  font-size: 1.25rem;
  font-weight: 700;
}
.detail-table thead th {
  background: linear-gradient(
    135deg,
    rgba(144, 202, 249, 0.25) 0%,
    rgba(165, 214, 167, 0.25) 100%
  );
  font-weight: 600;
  color: #37474f;
}
.detail-table td,
.detail-table th {
  border: 1px solid rgba(144, 202, 249, 0.25);
}
.empty-state {
  padding: 12px 8px;
  color: #6b7280;
}

.neo-btn.v-btn {
  --bg: #f3f6fb;
  --hi: rgba(255, 255, 255, 0.95);
  background: var(--bg) !important;
  color: #263238 !important;
  border-radius: 14px !important;
  padding: 10px 16px !important;
  text-transform: none;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.08), -8px -8px 16px var(--hi) !important;
}
.neo-btn.v-btn::before {
  background-color: transparent !important;
}
</style>
